import { baseTheme } from '@src/theme';
import { Avatar } from 'antd';
import { styled } from 'styled-components';

export const StyledAvatar = styled(Avatar)`
    background-color: ${(props) =>
        props.theme?.colors?.secondary?.light?.contentBg ||
        baseTheme.colors.secondary.light.contentBg};
    border: 1px solid
        ${(props) =>
            props.theme?.colors?.secondary?.light?.divider ||
            baseTheme.colors.secondary.light.divider};
    color: ${(props) =>
        props.theme?.colors?.secondary?.main?.icon ||
        baseTheme.colors.secondary.main.icon};

    .ant-avatar-string {
        color: ${(props) =>
            props.theme?.colors?.secondary?.main?.text ||
            baseTheme.colors.secondary.main.text};
    }

    .avatar-icon {
        color: ${(props) =>
            props.theme?.colors?.secondary?.main?.icon ||
            baseTheme.colors.secondary.main.icon};
    }

    &[disabled] {
        filter: grayscale(1);
        opacity: 0.6;
    }

    &:hover {
        border-color: ${(props) =>
            props.theme?.colors?.primary?.main?.border ||
            baseTheme.colors.primary.main.border};
        .avatar-icon {
            color: ${(props) =>
                props.theme?.colors?.primary?.main?.icon ||
                baseTheme.colors.primary.main.icon};
        }
        .ant-avatar-string {
            color: ${(props) =>
                props.theme?.colors?.primary?.main?.text ||
                baseTheme.colors.primary.main.text};
        }
    }
`;

export const StyledAvatarContainer = styled.div`
    display: flex;
    align-items: center;
`;
